import { formatDate } from "../../shared_critical/helper";
let dateNow = new Date(),
          current = new Date(dateNow.getTime() + 86400000),
          formattedDate = formatDate(current);

export const abOpenHouseTimePicker = () => {
  if ($('.ab-datetimepicker').length >= 1) {
    $('.ab-datetimepicker').datetimepicker({
        format: 'LT',
        icons: {
          up: 'ra ra-angle-up',
          down: 'ra ra-angle-down'
        },
        ignoreReadonly: true,
        stepping: 15,
        keepOpen: false,
        enabledHours: [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
        widgetPositioning: {
          horizontal: 'right',
          vertical: 'bottom'
        },
        allowInputToggle: true,
        ignoreReadonly: true,
        focusOnShow: false,
        useCurrent: false
    });
  }
}

export const abOpenHouseDatePicker = () => {
  if ($('.ab-datepicker').length >= 1) {
    $('.ab-datepicker').datepicker({
        startDate: '+0d',
        todayHighlight: true,
        autoclose: true,
        orientation: 'bottom auto',
        onClose: function() {
          $(this).change();
        }
    });
  }
}

export const abPopulateForm = () => {
  let $dateTimePickerForm = $('.ab-datetimepicker.oh-form input'),
      $datePickerForm = $('.ab-datepicker.oh-form input');
  if (MOVE_DATA.ab_schedule_tour === "V2" && !MOVE_DATA.is_flipped_market) {
    let date = $datePickerForm.val() || formattedDate;
    let time = $dateTimePickerForm.val() || "10:00 AM";
    let message = "I would like to request a showing on " + date + " at " + time;
    $("#request_showing_lead_message").val(message);
  }
}

export const abSetDateTime = () => {
  let $abDatePicker = $('.ab-datepicker'),
      $abDateTimePicker = $('.ab-datetimepicker'),
      $dateTimePickerInput = $('.ab-datetimepicker input'),
      $datePickerInput = $('.ab-datepicker input'),
      $dateTimePickerForm = $('.ab-datetimepicker.oh-form input'),
      $datePickerForm = $('.ab-datepicker.oh-form input');

  if ($abDatePicker && $abDateTimePicker) {
    //QV
    if (!$dateTimePickerInput.val())
      $dateTimePickerInput.val("10:00 AM");
    if (!$datePickerInput.val())
      $datePickerInput.val(formattedDate);
    
    //Forms
    if (!$dateTimePickerForm.val()) {
      $dateTimePickerForm.val("10:00 AM");
    } else {
      let newVal = $dateTimePickerInput.val();
      $dateTimePickerForm.val(newVal);
    }

    if (!$datePickerForm.val()) {
     $datePickerForm.val(formattedDate);
    } else {
      let newVal = $datePickerInput.val();
     $datePickerForm.val(newVal);
    }

    $datePickerInput.change(function() {
      abPopulateForm();
    });

    $datePickerForm.on('changeDate', function() {
      if (!$datePickerForm.val())
        $datePickerForm.val(formattedDate);
    });

    $('.ab-datetimepicker.oh-form').on('dp.change', function() {
      abPopulateForm();
    });

    $abDatePicker.off('click').on('click', function () {
      $('.bootstrap-datetimepicker-widget').hide();
    });

    $abDateTimePicker.off('click').on('click', function () {
      $('.datepicker-dropdown').hide();
    });
  }
}


// WEBPACK FOOTER //
// ./quick_view/optimization/ab-hlt-open-house.js